import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/common';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <p className="text-6xl font-bold text-primary-600">404</p>
        <h1 className="mt-4 text-3xl font-bold text-gray-900">Page not found</h1>
        <p className="mt-2 text-gray-500">
          Sorry, we could not find the page you are looking for.
        </p>
        <div className="mt-6">
          <Link to="/dashboard">
            <Button leftIcon={<HomeIcon className="w-5 h-5" />}>Go to Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
